import i18next from 'i18next';
import React, { useEffect, useState } from 'react';
import { SelectContainerLanguage, SelectLanguage } from './Language.styled';

const Language = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('de');

  useEffect(() => {
    const saveLanguage = localStorage.getItem('chosenLanguage');
    if (saveLanguage) {
      i18next.changeLanguage(saveLanguage);
      setSelectedLanguage(saveLanguage);
    } else {
      i18next.changeLanguage('de');
      localStorage.setItem('chosenLanguage', 'de');
    }
  }, []);

  const changeLanguage = event => {
    const language = event.target.value;
    i18next.changeLanguage(language);
    localStorage.setItem('chosenLanguage', language);
    setSelectedLanguage(language);
  };

  return (
    <SelectContainerLanguage>
      <SelectLanguage onChange={changeLanguage} value={selectedLanguage}>
        <option value="de">De</option>
        <option value="en">En</option>
      </SelectLanguage>
    </SelectContainerLanguage>
  );
};

export default Language;
